import { render } from "./Footer.vue?vue&type=template&id=669082ee"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__